// extracted by mini-css-extract-plugin
export var equalColumn = "_ek-0";